// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar-3tSv1","avatar_img":"avatar_img-1lpbk"};